var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44073_25122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24219 26.9581C4.06805 34.574 11.3989 40.0015 19.9982 40.0015C28.5975 40.0015 35.9284 34.574 38.7542 26.9581L19.9982 25.219L1.24219 26.9581Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9982 0.0012207C11.3989 0.0012207 4.06805 5.42872 1.24219 13.0447L19.9982 14.7838L38.7542 13.0447C35.9284 5.42872 28.5975 0.0012207 19.9982 0.0012207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24398 13.043C0.440078 15.2096 0 17.553 0 19.9995C0 22.4459 0.440078 24.7893 1.24398 26.9559H38.7561C39.56 24.7893 40 22.4459 40 19.9995C40 17.553 39.56 15.2096 38.756 13.043H1.24398Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44073_25122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.224b08b61320c1cda0203ef9f5803c9b.svg";
export { ForwardRef as ReactComponent };